export type ThemeMode = 'light' | 'dark';

export interface ThemeConfig {
  color1: string; // Primary color
  color2: string; // Secondary color
  color3: string; // Accent color
  color4: string; // Success/Positive color
  color5: string; // Warning/Alert color
  backgroundColor: string;
  textColor: string;
  buttonColor: string;
  buttonTextColor: string;
  // Border radius for input fields and form elements
  inputBorderRadius?: string; // Default: '8px'
  // Dark mode colors
  darkBackgroundColor?: string;
  darkTextColor?: string;
  darkCardBackground?: string;
  darkBorderColor?: string;
  // Legacy support
  primaryColor?: string;
  secondaryColor?: string;
}

export interface AppConfig {
  logo: string;
  backgroundImage: string;
  theme: ThemeConfig;
  companyName: string;
  poweredBy: string;
  mode?: ThemeMode; // light or dark
}

// Predefined theme presets
export interface ThemePreset {
  name: string;
  theme: ThemeConfig;
}

export const THEME_PRESETS: ThemePreset[] = [
  {
    name: 'Blue Healthcare',
    theme: {
      color1: '#2563eb',
      color2: '#1e40af',
      color3: '#3b82f6',
      color4: '#10b981',
      color5: '#f59e0b',
      backgroundColor: '#ffffff',
      textColor: '#1f2937',
      buttonColor: '#2563eb',
      buttonTextColor: '#ffffff',
      inputBorderRadius: '8px',
      primaryColor: '#2563eb',
      secondaryColor: '#1e40af'
    }
  },
  {
    name: 'Green Healthcare',
    theme: {
      color1: '#10b981',
      color2: '#059669',
      color3: '#34d399',
      color4: '#3b82f6',
      color5: '#f59e0b',
      backgroundColor: '#ffffff',
      textColor: '#1f2937',
      buttonColor: '#10b981',
      buttonTextColor: '#ffffff',
      inputBorderRadius: '8px',
      primaryColor: '#10b981',
      secondaryColor: '#059669'
    }
  },
  {
    name: 'Purple Healthcare',
    theme: {
      color1: '#8b5cf6',
      color2: '#7c3aed',
      color3: '#a78bfa',
      color4: '#10b981',
      color5: '#f59e0b',
      backgroundColor: '#ffffff',
      textColor: '#1f2937',
      buttonColor: '#8b5cf6',
      buttonTextColor: '#ffffff',
      inputBorderRadius: '8px',
      primaryColor: '#8b5cf6',
      secondaryColor: '#7c3aed'
    }
  },
  {
    name: 'Teal Healthcare',
    theme: {
      color1: '#14b8a6',
      color2: '#0d9488',
      color3: '#5eead4',
      color4: '#10b981',
      color5: '#f59e0b',
      backgroundColor: '#ffffff',
      textColor: '#1f2937',
      buttonColor: '#14b8a6',
      buttonTextColor: '#ffffff',
      inputBorderRadius: '8px',
      primaryColor: '#14b8a6',
      secondaryColor: '#0d9488'
    }
  }
];
